// extracted by mini-css-extract-plugin
export default {"email_Box":"Form_email_Box__XoGtR","radio_box":"Form_radio_box__95M2o"};